export default __webpack_public_path__ + "static/media/FKGroteskNeue-Black.859d5387.woff";